/**
 * 设置标签组件
 * created by yxy
 *
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Icon, Modal, Select, Tag, TreeSelect} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {message} from './Mess'
import CmForm from "../../../components/CmForm/CmForm";
const {Option} = Select;
const { SHOW_PARENT } = TreeSelect;

export default class DownLoad  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            TagList:[],//下拉的tag
            selectLabel:[],//选择的label
            label:false,
            size: 'default',
          

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }
    render() {
        return(
            <div>
                <div onClick={() => {this.SetLabel()
                }}>{
                    this.props.text?<span style={{cursor:"pointer"}}>设置标签</span>: <Button style={{marginRight: 5}} icon={"tag"} >设置标签</Button>
                }
                </div>
                {this.renderModel()}

            </div>

        )
    }

    renderModel(){
        let {TagList,selectLabel} = this.state;
        const children = [];
        TagList && TagList.length && TagList.map((item, index) => {

                if (item) {
                    children.push(<Option value={item.name} label={item.id} key={item.name}>{item.name}</Option>);
                }
            }
        );
        return(
            <Modal
                maskClosable={false}
                title="设置标签"
                visible={this.state.label}
                onOk={()=>this.settingTab()}
                centered
                onCancel={() => {
                    this.setState({label: false})
                }}
                width={400}
            >
                <CmForm onSubmit={() => {
                    this.settingTab()
                }}>

                        <div style={{display: 'flex'}}>
                            <div style={{width: '100%', marginRight: '10px'}}>
                                <Select
                                    autoFocus
                                    destroyOnClose={true}
                                    mode="tags"
                                    size={this.state.size}
                                    placeholder="请输入或选择标签"
                                    defaultValue={this.state.selectLabel}
                                    value ={this.state.selectLabel}
                                    onChange={(value)=>{
                                        this.handleChange(value)
                                    }}
                                    onFocus={()=>{
                                        this.setState({TagList:[]})
                                    }}
                                    style={{ width: '100%' }}
                                    onSearch={(value)=>{
              
                                        this.getTagList(value)}}
                                >
                                    {children}
                                </Select>
                            </div>
                        </div>
                </CmForm>
            </Modal>
        )
    }


    handleSizeChange = e => {
        this.setState({ size: e.target.value });
    };

    settingTab(){
        let ids = [];
        this.props.checkArray&&this.props.checkArray.length&&this.props.checkArray.forEach((item,index)=>{
           if(this.props.IsDefault) {
               ids.push(item.virtualFileId)
           }else{
               ids.push(item.id)
           }

        });
        if(!this.state.selectLabel.length){
            message.error('请输入或选择一个标签！');
            return false
        }
        let param={
            labelNames:this.state.selectLabel.join(','),
            virtualFileIds:ids.join(',')
        };
        this.request({
            url: "/cm-sites-storage-management/zykFile/addLabels",
            method: "post",
            body: param,
            contentType:'json',
            callBack: (data) => {
                if(data){
                    message.success('添加标签成功');
                    this.setState({label:false});
                    // this.props.callBack&&this.props.callBack(this.props.currentId,this.props.current,this.props.checkArray,false,false)
                    this.props.callBack&&this.props.callBack()
                }
            }
        });
    }
    //设置标签
    SetLabel(){
        this.props.hideCallBack&&this.props.hideCallBack();
        if (this.props.checkArray.length) {this.setState({label: true,TagList:[],selectLabel:[]})}
        else{message.error('至少选择一个文件夹或者文件！')}
    }
    handleChange = selectLabel => {
        let array =[];
        selectLabel&&selectLabel.length&&selectLabel.forEach((item,index)=>{
            let name = item.trim()
            if(name.length>50){
                name = name.substring(0, 50) ;
            }
            let pattern = new RegExp('[\/:*?"<>|]')
            let  rs = "";
            for (var i = 0; i < name.length; i++) {
                rs = rs + name.substr(i, 1).replace(pattern, '');
            }
            let newName =rs.trim()
            if(newName.length){
                array.push(newName)
            }
        });
        this.setState({ selectLabel:array })
    };
    


    getTagList(value){
        if(value){
            this.request({
                url: "/cm-sites-storage-management/label/searchByName",
                method: "post",
                body: {searchByName:value},
                contentType:'json',
                callBack: (data) => {
                    this.setState({TagList:data},()=>{
                    })
                }
            });
        }else{
            this.setState({TagList:[]})
        }

    }

}
